import script from "./BookDateHour.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookDateHour.vue?vue&type=script&setup=true&lang=ts"

import "./BookDateHour.vue?vue&type=style&index=0&id=b6ccb4f2&lang=scss"

const __exports__ = script;

export default __exports__